import React, { useRef, useState } from "react";
import { Button, message, Modal, Typography, Slider } from "antd";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

const SnippingCropper = ({
  imageSrc,
  open,
  onClose,
  onCropDone,
  setBodingBox,
}: any) => {
  const cropperRef: any = useRef<HTMLImageElement>(null);
  const [loading, setLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(false);
  const [rotationAngle, setRotationAngle] = useState(0);
  const { Text } = Typography;

  const rotateImage = (angle: number) => {
    setRotationAngle(angle);
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      cropper.rotateTo(angle); // rotate image
    }
  };

  const getCropData = () => {
    setDataLoading(true);
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const canvasData = cropper.getCanvasData();
      const cropBoxData = cropper.getCropBoxData();
      const x1 = cropBoxData.left - canvasData.left;
      const y1 = cropBoxData.top - canvasData.top;
      const x2 = x1 + cropBoxData.width;
      const y2 = y1 + cropBoxData.height;

      const { naturalWidth, naturalHeight } = cropper.getImageData();
      const scaleX = naturalWidth / canvasData.width;
      const scaleY = naturalHeight / canvasData.height;

      const boundingBox = {
        crop: [
          [
            { x: x1 * scaleX, y: y1 * scaleY },
            { x: x2 * scaleX, y: y1 * scaleY },
            { x: x2 * scaleX, y: y2 * scaleY },
            { x: x1 * scaleX, y: y2 * scaleY },
          ],
        ],
      };

      cropper.getCroppedCanvas().toBlob((blob: any) => {
        if (blob) {
          onCropDone(blob, boundingBox);
          message.success("Crop saved");
          onClose();
        }
        setDataLoading(false);
      });
    } else {
      setDataLoading(false);
    }
  };

  const resetCropper = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      cropper.clear();
      cropper.reset();
      cropper.rotateTo(0);
      setRotationAngle(0);
    }
  };

  const handleClose = () => {
    resetCropper();
    setBodingBox(null);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      closable={false}
      className="custom-crop-modal"
    >
      <div style={{ height: 400, width: "100%", position: "relative" }}>
        {loading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255, 255, 255, 0.7)",
              zIndex: 10,
            }}
          >
            <Text type="secondary">Loading image...</Text>
          </div>
        )}

        {imageSrc && (
          <Cropper
            src={imageSrc}
            style={{ height: 400, width: "100%" }}
            initialAspectRatio={NaN}
            guides={true}
            viewMode={1}
            background={false}
            responsive={true}
            autoCropArea={0.5}
            checkOrientation={false}
            ref={cropperRef}
            ready={() => setLoading(false)}
          />
        )}
      </div>
      {/* ✅ Rotate Slider Added */}
      {!loading && (
        <div style={{ marginTop: 16 }}>
          <Text>Rotate</Text>
          <Slider
            min={-180}
            max={180}
            value={rotationAngle}
            onChange={rotateImage}
          />
        </div>
      )}

      {/* Footer */}
      <div
        style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          onClick={handleClose}
          style={{ marginRight: 8 }}
          disabled={dataLoading}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          loading={dataLoading}
          onClick={getCropData}
          disabled={loading}
        >
          Crop
        </Button>
      </div>
    </Modal>
  );
};

export default SnippingCropper;
